import React from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

const images = [
  {
    original: "https://picsum.photos/id/1018/1000/600/",
    thumbnail: "https://picsum.photos/id/1018/250/150/",
  },
  {
    original: "https://picsum.photos/id/1015/1000/600/",
    thumbnail: "https://picsum.photos/id/1015/250/150/",
  },
  {
    original: "https://picsum.photos/id/1019/1000/600/",
    thumbnail: "https://picsum.photos/id/1019/250/150/",
  },
];

const ReactImageGallery = ({ imagesArray }) => {
  const hasVideos = imagesArray?.some((media) => media.endsWith(".mp4"));

  const finalItems =
    imagesArray?.length > 0
      ? imagesArray?.map((media) => ({
          original: media,
          thumbnail: media.endsWith(".mp4") ? media : media,
          embedUrl: media.endsWith(".mp4") ? media : null,
          renderItem: (item) =>
            item.embedUrl ? (
              <video controls style={{ width: "100%" }}>
                <source src={item.embedUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img src={item.original} alt="media" />
            ),
        }))
      : images;

  return (
    <ImageGallery
      items={finalItems}
      showPlayButton={!hasVideos}
      showFullscreenButton={!hasVideos}
    />
  );
};

export default ReactImageGallery;
